/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatientAcceptedStatusResponseDto
 */
export interface PatientAcceptedStatusResponseDto {
    /**
     * Status of patient treatment plan acceptance
     * @type {string}
     * @memberof PatientAcceptedStatusResponseDto
     */
    status: PatientAcceptedStatusResponseDtoStatusEnum;
    /**
     * Status message
     * @type {string}
     * @memberof PatientAcceptedStatusResponseDto
     */
    message: string;
}


/**
 * @export
 */
export const PatientAcceptedStatusResponseDtoStatusEnum = {
    NotFound: 'not_found',
    Pending: 'pending',
    Accepted: 'accepted'
} as const;
export type PatientAcceptedStatusResponseDtoStatusEnum = typeof PatientAcceptedStatusResponseDtoStatusEnum[keyof typeof PatientAcceptedStatusResponseDtoStatusEnum];


/**
 * Check if a given object implements the PatientAcceptedStatusResponseDto interface.
 */
export function instanceOfPatientAcceptedStatusResponseDto(value: object): value is PatientAcceptedStatusResponseDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function PatientAcceptedStatusResponseDtoFromJSON(json: any): PatientAcceptedStatusResponseDto {
    return PatientAcceptedStatusResponseDtoFromJSONTyped(json, false);
}

export function PatientAcceptedStatusResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientAcceptedStatusResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function PatientAcceptedStatusResponseDtoToJSON(json: any): PatientAcceptedStatusResponseDto {
    return PatientAcceptedStatusResponseDtoToJSONTyped(json, false);
}

export function PatientAcceptedStatusResponseDtoToJSONTyped(value?: PatientAcceptedStatusResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'message': value['message'],
    };
}

